/*
export function someMutation (state) {
}
*/

export function SET_SCOPE(state, scope) {
  state.scope = scope;
}
